import { atom } from "recoil"

export const hasUnreadThreadMessageRequestIdState = atom({
  key: "atoms/contact/hasUnreadThreadMessageRequestIdState",
  default: 0,
})
